import * as React from 'react';

import { IconProps, IconSize } from './icon.types';
import { IconWrapper } from './icon.styles';

export const Icon: React.FC<IconProps> = ({
  icon: Svg,
  color = 'inherit',
  reverse = false,
  size = IconSize.M,
}) => (
  <IconWrapper $color={color} $reverse={reverse} $size={size}>
    <Svg width="100%" height="100%" preserveAspectRatio="xMaxYMid meet" />
  </IconWrapper>
);
